'use strict';

var resolvers = {
  round: {
    round: round
  },

  token: {
    token: token
  },

  intro: {
    intro: intro
  },

  basis: {
    round: round,
    basis: basis
  },

  distribution: {
    round: round,
    distribution: distribution
  },

  questionnaire: {
    token: token,
    step: step,
    questionnaire: questionnaire
  },

  summary: {
    summary: summary
  },

  rounds: {
    rounds: listRound
  },

  overview: {
    invites: listInvitesAsCoworker
  },

  invites: {
    round: round,
    invites: listInvite
  }
};

function token($route) {
  return $route.current.params.token;
}

function step($route) {
  return parseInt($route.current.params.step);
}

function round($route) {
  return parseInt($route.current.params.round);
}

function basis($route, salaryService) {
  return salaryService.retrieve.basis(round($route));
}

function distribution($route, salaryService) {
  return salaryService.retrieve.distribution(round($route));
}

function questionnaire($route, salaryService) {
  return salaryService.retrieve.questionnaire(token($route), step($route));
}

function summary($route, salaryService) {
  return salaryService.retrieve.summary(token($route));
}

function listRound(salaryService) {
  return salaryService.list.round();
}

function listInvitesAsCoworker(salaryService) {
  return salaryService.list.invitesAsCoworker();
}

function listInvite($route, salaryService) {
  return salaryService.list.invite(round($route));
}

function intro($route, salaryService) {
  return salaryService.retrieve.intro(token($route));
}
module.exports = resolvers;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/resolve/index.js
 ** module id = 320
 ** module chunks = 0
 **/